export default "__VITE_ASSET__9d9712ab__$_?component__"